import { RefObject, useEffect, useMemo, useState } from 'react';

type Params = {
  ref: RefObject<HTMLElement | null> | null;
  observerOptions?: ResizeObserverOptions;
  customOptions?: { pause?: boolean };
};

const useDimensionsObserver = (params?: Params): DOMRectReadOnly | null => {
  const { ref, observerOptions, customOptions } = params || {};

  const [dimensions, setDimensions] = useState<DOMRectReadOnly | null>(null);

  const pause = useMemo(() => !!customOptions?.pause, [customOptions?.pause]);

  useEffect(() => {
    const _ref = ref?.current;
    if (!_ref || pause) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries?.[0];
      if (entry) {
        setDimensions(entry.contentRect);
      }
    });

    observer.observe(_ref, observerOptions);

    return () => {
      observer.unobserve(_ref);
    };
    // note: do NOT pass `customOptions` into the deps array or we'll get infinite loops
  }, [observerOptions, ref, pause]);

  return useMemo(() => dimensions, [dimensions]);
};

export default useDimensionsObserver;
